<template>
    <header class="header">
        <app-creation-modal :data-activator-text="$t('message.generics.message.register')"
                            data-entity="tag"></app-creation-modal>

		<div class="search-wrapper">
			<app-search @submit="search"/>
		</div>
    </header>
</template>
<script>
import AppCreationModal from './tag-modal/TagModal'
import EventBus from '@packages/event-bus/index'
import AppSearch from '@components/Search'
export default {
    components: {
        AppCreationModal,
        AppSearch
    },

    methods: {
        search(search) {
            EventBus.$emit('GO_TO_FIRST_PAGE')
            this.$store.commit('TAG_SET_FILTER', {key: 'search', value: search})
        },
    },
}
</script>
<style scoped>
    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

</style>
